<template>
    <b-card no-body>

        <b-modal id="create-or-update" size="lg" :title="editing ? 'Araç Güncelle' : 'Araç Oluştur'" no-close-on-esc no-close-on-backdrop>
            <vehicle-create-or-update v-model="vehicle" :errors="errors"></vehicle-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :add-callback="createNew"
                    name="vehicle"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    search></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import VehicleDefinitionsApi from '@/api/vehicle-definitions'
import VehicleCreateOrUpdate from './components/VehicleCreateOrUpdate.vue'

export default {
    components:{
        BCard,
        VehicleCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            errors:{},
            loading:false,
            vehicle:{
                Id:0,
                VehicleTypeId:0,
                VehicleBrandId:0,
                VehicleBrandModelId:0,
                VehicleBrandModelSerialId:0,
                FuelTypeId:0,
                VehicleModelYear:0,
                FuelTankCapacity1:50,
                FuelTankCapacity2:50,
                IsHasAdBlue:false,
                AdBlueCapacity:0,
                EmissionTypeId:0,
                EmptyWeight:0,
                MaxNotEmptyWeight:0,
                VehicleTypeBaseTypeId:0
            },
            fields:[
                { name:"Araç Ana Tipi",key:"VehicleTypeBaseTypeName", thClass:"w-20",sortable:true,sortKey:'VehicleType.VehicleTypeBaseType.Name'},
                { name:"Tip",key:"VehicleTypeName", thClass:"w-20",sortable:true,sortKey:'VehicleType.Name'},
                { name:"Marka",key:"VehicleBrandName", thClass:"w-20",sortable:true,sortKey:'VehicleBrand.Name',tdClass:"text-nowrap"},
                { name:"Model",key:"VehicleBrandModelName", thClass:"w-20",sortable:true,sortKey:'VehicleBrandModel.Name'},
                { name:"Seri",key:"VehicleBrandModelSerialName", thClass:"w-20",sortable:true,sortKey:'VehicleBrandModelSerial.Name'},
                { name:"Yakıt Tipi",key:"FuelTypeName", thClass:"w-20",sortable:true,sortKey:'FuelType.Name'},
                { name:"Model Yılı",key:"VehicleModelYear", thClass:"w-20",tdClass:"text-right",sortable:true},
                { name:"Yakıt Depo Kapasitesi 1 (LT)",key:"FuelTankCapacity1", thClass:"w-20",tdClass:"text-right",sortable:true},
                { name:"Yakıt Depo Kapasitesi 2 (LT)",key:"FuelTankCapacity2", thClass:"w-20",tdClass:"text-right",sortable:true},
                { name:"Ad Blue Kapasitesi (LT)",key:"AdBlueCapacity", thClass:"w-20",tdClass:"text-right",sortable:true},
                { name:"Emisyon Tipi",key:"EmissionTypeName", thClass:"w-20",sortable:true,sortKey:'EmissionType.Name'},
                { name:"Boş Ağırlığı (TON)",key:"EmptyWeight", thClass:"w-20",tdClass:"text-right",sortable:true,},
                { name:"Dolu Ağırlığı (TON)",key:"MaxNotEmptyWeight", thClass:"w-20",tdClass:"text-right",sortable:true},
                
                
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.vehicle.Id = 0
            this.vehicle.VehicleTypeId=0,
            this.vehicle.VehicleBrandId=0,
            this.vehicle.VehicleBrandModelId=0,
            this.vehicle.VehicleBrandModelSerialId=0,
            this.vehicle.FuelTypeId=0,
            this.vehicle.VehicleModelYear=new Date().getFullYear(),
            this.vehicle.FuelTankCapacity1=50,
            this.vehicle.FuelTankCapacity2=50,
            this.vehicle.IsHasAdBlue=false,
            this.vehicle.AdBlueCapacity=0,
            this.vehicle.EmissionTypeId=0,
            this.vehicle.EmptyWeight=0,
            this.vehicle.MaxNotEmptyWeight=0,
            this.vehicle.VehicleTypeBaseTypeId=0
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.vehicle.Id = item.Id
            this.vehicle.VehicleTypeId=item.VehicleTypeId
            this.vehicle.VehicleBrandId=item.VehicleBrandId
            this.vehicle.VehicleBrandModelId=item.VehicleBrandModelId
            this.vehicle.VehicleBrandModelSerialId=item.VehicleBrandModelSerialId
            this.vehicle.FuelTypeId=item.FuelTypeId
            this.vehicle.VehicleModelYear=item.VehicleModelYear
            this.vehicle.FuelTankCapacity1=item.FuelTankCapacity1
            this.vehicle.FuelTankCapacity2=item.FuelTankCapacity2
            this.vehicle.IsHasAdBlue=item.IsHasAdBlue
            this.vehicle.AdBlueCapacity=item.AdBlueCapacity
            this.vehicle.EmissionTypeId=item.EmissionTypeId
            this.vehicle.EmptyWeight=item.EmptyWeight
            this.vehicle.MaxNotEmptyWeight=item.MaxNotEmptyWeight
            this.vehicle.VehicleTypeBaseTypeId=item.VehicleTypeBaseTypeId
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            VehicleDefinitionsApi.Vehicle.CreateOrUpdate(this.editing,this.vehicle)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                
                this.$result(res)
                this.loading = false
            }).catch(error=>{
                if (error.response) {
                    this.$result(error.response)
                }
                this.loading = false
            })
        },
        provider(data){
            return VehicleDefinitionsApi.Vehicle.Table(data)
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} aracını silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    VehicleDefinitionsApi.Vehicle.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>